var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('Detail',{attrs:{"order":_vm.order,"showAction":_vm.showAction},on:{"close":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }